import { Country } from '../../enums/Country';
import { IDType } from '../../enums/IDType';
import { IdCardInfo } from '../types/IdCardInfo';
import { VerifyInfo as VerifyInfoI } from '../types/VerifyInfo';

export class VerifyInfo implements VerifyInfoI {
    type?: number | undefined;

    status?: number | undefined;

    userId: number | undefined;

    idType: IDType = IDType.IdCard;

    frontImgUrl?: string | undefined;

    backImgUrl?: string | undefined;

    handImgUrl?: string | undefined;

    passportImgUrl?: string | undefined;

    idCardName?: string | undefined;

    idCardNo?: string | undefined;

    birthday?: Date | undefined;

    startDate?: Date | undefined;

    endDate?: Date | undefined;

    address?: string | undefined;

    country: Country = Country.China;

    settleAddress?: string | undefined;

    bankCardName: string | undefined;

    bankCardNo?: string | undefined;

    bankName?: string | undefined;

    swiftCode?: string | undefined;

    cnapsCode?: string | undefined;

    branch?: string | undefined;

    bankAddress?: string | undefined;

    bankId?: string | undefined;

    businessLicImgUrl?: string | undefined;

    powerOfAttorneyImgUrl?: string | undefined;

    foreignTradeImgUrl?: string | undefined;

    companyName?: string | undefined;

    companyEnName?: string | undefined;

    companySetUpTime?: Date | undefined;

    taxNum?: string | undefined;

    companyPostCode?: string | undefined;

    companyType?: string | undefined;

    companyRegisteredAddr?: string | undefined;

    shareHolders: IdCardInfo[] = [];

    contractImgUrl?: string | undefined;

    finalContractImgUrl?: string | undefined;

    legalLetterImgUrl?: string | undefined;

    addressImgUrl?: string | undefined;

    residenceCertImgUrl?: string | undefined;

    specialBusLicImgUrl?: string | undefined;

    officeLeaseAgreeImgUrl?: string | undefined;

    bkpmLetterImgUrl?: string | undefined;

    taxCardImgUrl?: string | undefined;

    companyEmail?: string | undefined;

    productName?: string | undefined;

    companyUrl?: string | undefined;

    businessDesc?: string | undefined;

    companyOfficeAddr?: string | undefined;

    perDayQuantity?: number | undefined;

    perMonthQuantity?: number | undefined;

    perDayAmount?: number | undefined;

    perMonthAmount?: number | undefined;

    businessRegImgUrl?: string | undefined;

    companyRegImgUrl?: string | undefined;

    msolicImgUrl?: string | undefined;

    companyExpiryTime?: Date | undefined;

    regCertNoPrefix8?: string | undefined;

    itPrincipalName?: string | undefined;

    itPrincipalPhone?: string | undefined;

    itPrincipalEmail?: string | undefined;

    businessPrincipalName?: string | undefined;

    businessPrincipalPhone?: string | undefined;

    businessPrincipalEmail?: string | undefined;

    csPrincipalName?: string | undefined;

    csPrincipalPhone?: string | undefined;

    csPrincipalEmail?: string | undefined;

    financePrincipalName?: string | undefined;

    financePrincipalPhone?: string | undefined;

    financePrincipalEmail?: string | undefined;
}
